import { render, staticRenderFns } from "./MidGlobalPanel.vue?vue&type=template&id=27196ea6&"
import script from "./MidGlobalPanel.vue?vue&type=script&lang=js&"
export * from "./MidGlobalPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports